<template>
	<div class="flex flex-col h-full p-4 rounded-md bg-neutral-900">
		<div class="flex items-start gap-3 mb-4" data-test="trait-heading">
			<TraitBadge :trait="row.key" class="!w-8 !h-8 shrink-0" />
			<div class="min-w-0" data-test="trait-copy">
				<p class="mb-0 font-semibold text-white uppercase font-heading">
					{{ row.label }}
				</p>
				<p class="mt-1 mb-0 text-sm leading-5 text-grey-400">
					{{ $t(row.sloganKey) }}
				</p>
			</div>
		</div>
		<div class="flex items-center gap-3 mt-auto" data-test="trait-progress">
			<div
				class="h-1.5 flex-1 overflow-hidden rounded-full bg-neutral-700"
			>
				<div
					class="h-full rounded-full"
					:style="{
						width: `${row.percent}%`,
						backgroundColor: row.color
					}"
				/>
			</div>
			<p class="mb-0 text-sm text-right text-white shrink-0">
				{{ row.percent }}%
			</p>
		</div>
	</div>
</template>

<script>
import { TraitBadge } from '.'

export default {
	name: 'PersonalityTraitCompactCard',
	components: {
		TraitBadge
	},
	props: {
		row: {
			type: Object,
			required: true
		}
	}
}
</script>
